export const environmentOptions = [
  {
    label: 'Live',
    value: 'live'
  },
  {
    label: 'Test',
    value: 'test'
  }
]

export const ipWhitelistOptions = [
  { label: 'Specific IP', value: 'Specific' },
  { label: 'IP Range', value: 'Range' }
]
